import { Injectable } from '@angular/core';
import { SupportedStorage } from "@supabase/supabase-js";
import { Preferences } from "@capacitor/preferences";

@Injectable({
  providedIn: 'root'
})
export class CapacitorStorageService implements SupportedStorage {

  async getItem(key: string): Promise<string | null> {
    try {
      const { value } = await Preferences.get({ key });
      return value;
    } catch (error) {
      console.error('Error getting item from storage:', error);
      return null;
    }
  }

  async setItem(key: string, value: string): Promise<void> {
    try {
      await Preferences.set({ key, value });
    } catch (error) {
      console.error('Error setting item in storage:', error);
    }
  }

  async removeItem(key: string): Promise<void> {
    try {
      await Preferences.remove({ key });
    } catch (error) {
      console.error('Error removing item from storage:', error);
    }
  }
}
